import React from "react";

function InputField({ fieldName, required, handleOnChange, value }) {
  const isNumberField =
    fieldName === "Quantity" ||
    fieldName === "Estimated Price" ||
    fieldName === "Amount";

  const shouldTriggerChange =
    fieldName === "Quantity" ||
    fieldName === "Estimated Price" ||
    fieldName === "Description" ||
    fieldName === "Amount" ||
    fieldName === "Remarks" ||
    fieldName === "Received Items";

  return (
    <div className="fields">
      <span className="field-name">
        {fieldName} {required ? <span className="epr-required">*</span> : ""}
      </span>

      <input
        className={fieldName}
        type={isNumberField ? "number" : "text"}
        value={value || ""}
        onChange={(e) => {
          if (shouldTriggerChange) {
            handleOnChange(fieldName, e.target);
          }
        }}
      />
    </div>
  );
}

export default InputField;